/* eslint-disable */
const shellStoreState = (set, get) => ({
  user: null,
  setUser: (user) => {
    // When setting user, automatically set their franchise/store if available
    set({
      user,
      franchiseId: user?.franchiseId || null,
      storeId: user?.storeId || null,
    });
  },
  clearUser: () =>
    set({
      user: null,
      franchiseId: null,
      storeId: null,
      selectedStore: null,
    }),

  // Franchise state
  franchiseId: null,
  setFranchiseId: (franchiseId) => set({ franchiseId }),

  // Store state
  storeId: null,
  setStoreId: (storeId) => set({ storeId }),
  selectedStore: null,
  setSelectedStore: (store) =>
    set({
      selectedStore: store,
      storeId: store?._id || get().storeId,
    }),

  // Helper methods
  canAccessStore: (storeId) => {
    const state = get();
    const user = state.user;

    if (!user) return false;

    // Super admin can access all stores
    if (user.role === "super_admin") return true;

    // Brand owners can access all stores
    if (user.role === "brand_owner") return true;

    // Franchise owners can access stores in their franchise
    if (user.role === "franchise_owner") {
      return state.franchiseId === storeId;
    }

    // Store managers can only access their assigned store
    if (user.role === "store_manager") {
      return state.storeId === storeId;
    }

    return false;
  },

  // Global Alert state
  alertData: {
    show: false,
    type: "success", // 'success', 'error', 'warning', 'info'
    message: "",
  },
  showAlert: (type, message) => {
    set({
      alertData: {
        show: true,
        type,
        message,
      },
    });

    // Auto-hide alert after 5 seconds
    setTimeout(() => {
      set((state) => ({
        alertData: {
          ...state.alertData,
          show: false,
        },
      }));
    }, 5000);
  },
  hideAlert: () =>
    set((state) => ({
      alertData: {
        ...state.alertData,
        show: false,
      },
    })),
});

export default shellStoreState;
